export default __webpack_public_path__ + "static/media/emptyTag.136601e9.svg";